var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime } from 'luxon';
export var providerUnscheduledNoteSchemaInstance = {
    defaultValues: {
        sessionInfo: {
            start: DateTime.now().toString(),
        },
        interactionDate: new Date(),
        safetyPlan: {},
    },
    prepareExistingNote: function (note) {
        var _a, _b;
        // Prep to pull the start and end time into their own fields
        var interactionDate = DateTime.fromISO((_a = note.sessionInfo.start) !== null && _a !== void 0 ? _a : '');
        var interactionStart = DateTime.fromISO((_b = note.sessionInfo.start) !== null && _b !== void 0 ? _b : '');
        var interactionEnd = note.sessionInfo.end ? DateTime.fromISO(note.sessionInfo.end) : null;
        var preparedNote = __assign(__assign({}, note), { interactionDate: interactionDate.toJSDate(), interactionStartTime: interactionStart && note.setStartTime
                ? DateTime.local()
                    .set({
                    hour: interactionStart.hour,
                    minute: interactionStart.minute,
                    second: 0,
                    millisecond: 0,
                })
                    .toUTC()
                    .toISO()
                : null, interactionEndTime: interactionEnd
                ? DateTime.local()
                    .set({
                    hour: interactionEnd.hour,
                    minute: interactionEnd.minute,
                    second: 0,
                    millisecond: 0,
                })
                    .toUTC()
                    .toISO()
                : null });
        return preparedNote;
    },
    prepareFormForSave: function (form) {
        var _a;
        var formValues = form.getValues();
        // Prep to set the start and end time relative to the interaction date
        var interactionDate = DateTime.fromJSDate((_a = formValues.interactionDate) !== null && _a !== void 0 ? _a : new Date());
        var interactionStart = formValues.interactionStartTime
            ? DateTime.fromISO(formValues.interactionStartTime)
            : null;
        var interactionEnd = formValues.interactionEndTime
            ? DateTime.fromISO(formValues.interactionEndTime)
            : null;
        var preparedForm = __assign(__assign({}, formValues), { sessionInfo: __assign(__assign({}, form.getValues().sessionInfo), { start: interactionStart
                    ? interactionDate
                        .set({
                        minute: interactionStart.minute,
                        hour: interactionStart.hour,
                        second: 0,
                        millisecond: 0,
                    })
                        .toUTC()
                        .toISO()
                    : interactionDate.startOf('day'), end: interactionEnd
                    ? interactionDate
                        .set({
                        minute: interactionEnd.minute,
                        hour: interactionEnd.hour,
                        second: 0,
                        millisecond: 0,
                    })
                        .toUTC()
                        .toISO()
                    : undefined }), setStartTime: !!interactionStart });
        delete preparedForm.interactionDate;
        delete preparedForm.interactionStartTime;
        delete preparedForm.interactionEndTime;
        return preparedForm;
    },
};
